// Re-export i18n utilities for components
// Uses React Admin's translation system

import { useTranslate } from 'react-admin';

interface TranslationOptions {
    defaultValue?: string;
    count?: number;
    [key: string]: unknown;
}

// Custom hook that mimics react-i18next's useTranslation API
// but uses React Admin's translation system internally
export const useTranslation = () => {
    const translate = useTranslate();

    return {
        t: (key: string, defaultValueOrOptions?: string | TranslationOptions, options?: TranslationOptions): string => {
            let defaultValue: string | undefined;
            let translateOptions: Record<string, unknown> = {};

            if (typeof defaultValueOrOptions === 'string') {
                defaultValue = defaultValueOrOptions;
                if (options) {
                    translateOptions = options;
                }
            } else if (defaultValueOrOptions) {
                defaultValue = defaultValueOrOptions.defaultValue;
                translateOptions = defaultValueOrOptions;
            }

            const translated = translate(key, { _: defaultValue || key, ...translateOptions });
            return translated;
        },
        i18n: {
            language: 'de', // Default, could be made dynamic
            changeLanguage: () => {}, // Not implemented, use React Admin's locale switcher
        },
    };
};

// Also export useTranslate directly for convenience
export { useTranslate } from 'react-admin';
